import React from "react";
import Slider from "react-slick";
import Baiwang from "../../assets/images/carousel/baiwang.svg";
import BankOfChina from "../../assets/images/carousel/bank of china.svg";
import Beijing from "../../assets/images/carousel/Beijing Municipal Tax Service.svg";
import Casc from "../../assets/images/carousel/casc.svg";
import Deloite from "../../assets/images/carousel/Deloite.svg";
import Huawei from "../../assets/images/carousel/Huawei.svg";
import ICBC from "../../assets/images/carousel/ICBC.svg";
import Jiangxi from "../../assets/images/carousel/Jiangxi Provincial Tax Service.svg";
import Ministry from "../../assets/images/carousel/Ministry of Agriculture and Rural Affairs of the People’s Republic of china.svg";
import National from "../../assets/images/carousel/National Forestry and Grassland Administration.svg";
import PWC from "../../assets/images/carousel/pwc.svg";
import Shanghai from "../../assets/images/carousel/Shanghai Municipal Tax Service.svg";
import StateTaxation from "../../assets/images/carousel/State Taxation Administration.svg";
import TaxationBureau from "../../assets/images/carousel/Taxation Bureau of Xinjiang Uygur Autonomous Region-1.svg";
import TaxationBureauTwo from "../../assets/images/carousel/Taxation Bureau of Xinjiang Uygur Autonomous Region.svg";
import Variant from "../../assets/images/carousel/Variant16.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./carousel.css";

function Carousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // Tiempo en milisegundos entre cada cambio de imagen
    responsive: [
      {
        breakpoint: 767, // Cambia la configuración a pantallas de menos de 767px de ancho
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // Oculta las flechas de navegación en pantallas pequeñas
        },
      },
    ],
  };

  return (
    <div className="carousel-wrapper">
      <Slider {...settings}>
        <div>
          <img className="imgCarousel" src={Baiwang} alt="Imagen 1" />
      
        </div>
        <div>
          <img className="imgCarousel" src={BankOfChina} alt="Imagen 2" />
        </div>
        <div>
          <img className="imgCarousel" src={Beijing} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Casc} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Deloite} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Huawei} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={ICBC} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Jiangxi} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Ministry} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={National} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={PWC} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Shanghai} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={StateTaxation} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={TaxationBureau} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={TaxationBureauTwo} alt="Imagen 3" />
        </div>
        <div>
          <img className="imgCarousel" src={Variant} alt="Imagen 3" />
        </div>
      </Slider>
    </div>
  );
}

export default Carousel;
